// extracted by mini-css-extract-plugin
var _1 = "SelectControlSelectedItemsCounter-moduleSelectControlSelectedItemsCounter__fGXwY";
export { _1 as "SelectControlSelectedItemsCounter" }
